<script setup>
import SidebarHeaderButton from "@/features/Sidebar/SidebarHeaderButton.vue";
import InlineSvg from "@/features/InlineSvg.vue";
</script>
<template>
  <SidebarHeaderButton class="sidebar-close-button">
    <InlineSvg name="small-x" />
  </SidebarHeaderButton>
</template>
